// extracted by mini-css-extract-plugin
export var fadeIn = "fade-module--fadeIn--8021a";